import { render, staticRenderFns } from "./BindWXPre.vue?vue&type=template&id=494aa2dc&scoped=true&"
import script from "./BindWXPre.vue?vue&type=script&lang=js&"
export * from "./BindWXPre.vue?vue&type=script&lang=js&"
import style0 from "./BindWXPre.vue?vue&type=style&index=0&id=494aa2dc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494aa2dc",
  null
  
)

export default component.exports